import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { IconType } from "react-icons/lib";

interface CustomButtonProps extends ButtonProps {
  id: string;
  label: string;
  variant?: "primary" | "outline-primary" | "danger" | "warning" | "danger-alt" | "outline-dark";
  className?: string;
  rigthIcon?: IconType;
  leftIcon?: IconType;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  size?: "sm" | "lg";
  bigSize?: boolean;
  style?: React.CSSProperties;
}

const CustomButton: React.FC<CustomButtonProps> = (props) => {
  return (
    <>
      {props.bigSize ? (
        <div className="d-grid gap-2" style={props.style}>
          <Button
            id={props.id}
            type={props.type}
            variant={props.variant}
            onClick={props.onClick}
            disabled={props.disabled}
            className={props.className}
            size={props?.size}
          >
            <span className={"icon-container"}>
              {props.leftIcon && <props.leftIcon className={"icon-left"} />}
              {props.label}
              {props.rigthIcon && <props.rigthIcon className={"icon-right"} />}
            </span>
          </Button>
        </div>
      ) : (
        <Button
          id={props.id}
          type={props.type}
          variant={props.variant}
          onClick={props.onClick}
          disabled={props.disabled}
          className={props.className}
          size={props?.size}
          style={props.style}
        >
          <span className={"icon-container"}>
            {props.leftIcon && <props.leftIcon className={"icon-left"} />}
            {props.label}
            {props.rigthIcon && <props.rigthIcon className={"icon-right"} />}
          </span>
        </Button>
      )}
    </>
  );
};

export default CustomButton;
